import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
const SLOTS = Array.from({
  length: 8
}).map((_, i) => `Cliente ${i + 1}`);

/**
 * Los logos y nombres de clientes se cargan únicamente desde la presentación
 * corporativa validada. Hasta esa validación, los espacios quedan reservados
 * y visiblemente marcados: no se publican clientes no verificados.
 */
export function ClientLogosCarousel() {
  const track = [...SLOTS, ...SLOTS];
  return <div className="relative overflow-hidden py-2" aria-label="Carrusel de logos de clientes" data-id="element-47" data-mp="oudrboh0qi1n">
      <div className="rb-marquee flex w-[200%] items-center gap-4" data-id="element-48" data-mp="kubpnfba9omd">
        {track.map((slot, i) => <div key={`${slot}-${i}`} className="group flex h-24 w-48 shrink-0 flex-col items-center justify-center border border-mist-200 bg-white px-4 text-center grayscale transition-[filter,border-color] duration-200 ease-smooth hover:border-brand-300 hover:grayscale-0" data-id="element-49" data-mp="ytl1y3wdbyl2" data-mpi={i}>
            <span className="font-display text-sm font-bold uppercase tracking-[0.12em] text-graphite-500 transition-colors duration-200 group-hover:text-brand-700" data-id="element-50" data-mp="25aggvid3tyt3">
              {slot}
            </span>
            <span className="mt-1.5 text-[10px] leading-tight text-graphite-500/70" data-id="element-51" data-mp="2bctkwv90grok">Logo pendiente de validación</span>
          </div>)}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-white" style={{
      maskImage: 'linear-gradient(to right, #000, transparent)'
    }} aria-hidden="true" data-id="element-52" data-mp="2l7v9npzdjrqm" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-white" style={{
      maskImage: 'linear-gradient(to left, #000, transparent)'
    }} aria-hidden="true" data-id="element-53" data-mp="1sjzfarxa2bx0" />
    </div>;
}
export function ProofStats() {
  return <div data-id="element-54" data-mp="22bvds43a041r">
      <dl className="grid gap-px bg-mist-200 sm:grid-cols-2" data-id="element-55" data-mp="22bmzc7ri8qog">
        {[{
        value: '+500',
        label: 'Proyectos completados'
      }, {
        value: '100%',
        label: 'Satisfacción informada en clientes recurrentes'
      }].map(stat => <div key={stat.label} className="bg-white p-7" data-id="element-56" data-mp="11stjekk66afj">
            <dt className="sr-only" data-id="element-57" data-mp="11r8q0y9lcxj9">{stat.label}</dt>
            <dd data-id="element-58" data-mp="wv0ervyilohd">
              <span className="block font-display text-5xl font-bold tabular-nums text-graphite-900" data-id="element-59" data-mp="wtgzo8olhjh6">{stat.value}</span>
              <span className="mt-3 block text-sm text-graphite-500" data-id="element-60" data-mp="1bid1ho02609c">{stat.label}</span>
            </dd>
          </div>)}
      </dl>
      <p className="mt-4 flex gap-2 border border-accent-300 bg-accent-300/10 p-3 text-[11px] leading-relaxed text-accent-600" data-id="element-61" data-mp="iu7fyz16k78g">
        <AlertTriangleIcon className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-62" data-mp="dwfqscrx6z7y" />
        <span data-id="element-63" data-mp="ssx0z0odi7sx">
          VALIDAR ANTES DE GO-LIVE — indicadores tomados de la presentación corporativa, sujetos a confirmación comercial
          antes de su publicación.
        </span>
      </p>
    </div>;
}
export function CaseStudyFramework() {
  const steps = ['Problema', 'Solución Rabemar', 'Implementación', 'KPI', 'Resultado'];
  return <div data-id="element-64" data-mp="1zatl42zg20ar">
      <ol className="grid gap-px bg-white/10 md:grid-cols-5" data-id="element-65" data-mp="1zb1x7snqt1kw">
        {steps.map((step, i) => <li key={step} className="bg-graphite-800 p-5" data-id="element-66" data-mp="26ul03jgi5pke" data-mpi={i}>
            <span className="font-display text-xs font-bold tabular-nums text-accent-400" data-id="element-67" data-mp="2bs4dyi9ag0bt">
              {String(i + 1).padStart(2, '0')}
            </span>
            <span className="mt-3 block font-display text-sm font-semibold uppercase tracking-[0.08em] text-white" data-id="element-68" data-mp="21svmpx5t4zt5">
              {step}
            </span>
          </li>)}
      </ol>
      <p className="mt-5 max-w-3xl text-sm leading-relaxed text-mist-300" data-id="element-69" data-mp="2uht3twya8qkb">
        Cada caso de éxito se publica con esta estructura y con datos provistos y aprobados por el cliente. No publicamos
        resultados ni indicadores que no hayan sido medidos en la operación.
      </p>
    </div>;
}